export const PRODUCT_CHAT_DISABLED_MESSAGE = "Chat is disabled for partner accounts"
